import { entity } from "@mhmo91/ican";
import { firestore } from "@mhmo91/ican/firestore/binding";
import type { Timestamp } from "firebase/firestore";
import { z } from "zod";
import { type Actor, Id } from "../workspace.entity.ts";
import { DnsRecordSchema } from "./domain.entity.ts";

// A request-bound observation of the provider's actionable records, not a
// replacement for Firebase Hosting's own DNS or certificate state.
const ActionableRecord = DnsRecordSchema.extend({
	requiredAction: DnsRecordSchema.shape.requiredAction.extract([
		"ADD",
		"REMOVE",
	]),
});
export const DomainDnsCheckSchema = z
	.object({
		requestId: Id,
		checkedAt: z.custom<Timestamp>(),
		records: z.array(
			z.discriminatedUnion("status", [
				ActionableRecord.extend({
					status: z.literal("checked"),
					present: z.boolean(),
				}),
				ActionableRecord.extend({
					status: z.literal("unavailable"),
					present: z.null(),
				}),
			]),
		),
	})
	.strict();
export type DomainDnsCheck = z.infer<typeof DomainDnsCheckSchema>;

export const DomainDnsCheck = entity<Actor>()({
	schema: DomainDnsCheckSchema,
	actions: ["read"] as const,
})
	.pipe(({ can, hasPermission, and }) => [
		can("read").when((_data, me) =>
			and(
				hasPermission(me.permissions, "workspace.domains.manage"),
				me.mfa.eq(true),
			),
		),
	])
	.adaptor(
		firestore({
			hierarchicalGrants: true,
			path: "workspaces/{orgId}/domains/{hostname}/dnsChecks/current",
		}),
	);
